export const checkDev = () => {
    const environmentsDEV = ['local', 'dev', 'releaseQA'];
    return environmentsDEV.includes(process.env.REACT_APP_ENVIRONMENT);
};
